import AsoHeader from '../../../components/Aso/Header';
import AsoValidarEmail from '../../../components/Aso/Register/AsoValidarEmail';

const AsoRegistroValidarEmail: React.FC = () => {

  return (
    <div>
      <AsoHeader />
      <AsoValidarEmail />
    </div>
  );
}

export default AsoRegistroValidarEmail